import React from "react";
import { Menu, MenuItem, IconButton, Button, Box, useMediaQuery } from "@mui/material";
import { styled } from "@mui/system";
// import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../../redux/slices/auth";
import { ReactComponent as AccountIcon } from "../../assets/icons/account.svg";
import FocusGhostButton from "./FocusGhostButton";
import { config } from "../../config";

const StyledMenu = styled(Menu)(({ theme }) => ({
  padding: "20px",
  // background: "#000000",
  border: "1px solid #323232",
  borderRadius: "4px",
  ".MuiList-root": {
    background: "#000"
  },
  ".MuiMenuItem-root": {
    minWidth: "240px",
    marginTop: "10px",

    "&:hover": {
      background: "rgba(255, 255, 255, 0.1)"
    }
  }
}));

const UserProfileMenu = () => {
  const dispatch = useDispatch();
  const { token } = useSelector((state) => state.auth);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down("sm"));

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <Box>
      <FocusGhostButton
        onClick={handleClick}
        className="profile-menu-handler"
        sx={{
          width: isMobile ? "85px" : "100%",
          minWidth: isMobile ? "85px" : "168px",
          height: isMobile ? "32px" : "100%",
          minHeight: isMobile ? "32px" : "50px",
          fontSize: isMobile ? "13px" : "16px"
        }}>
        <AccountIcon />
      </FocusGhostButton>
      <StyledMenu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        className="user-profile-dropdown-menu">
        <MenuItem
          onClick={handleClose}
          component={"a"}
          href={`${config.DELYSIUM_ONE_CLIENT_URL}fund`}
          target="_blank">
          <FocusGhostButton>AI FUND</FocusGhostButton>
        </MenuItem>
        <MenuItem onClick={handleClose} component={Link} to={"/"}>
          <FocusGhostButton>DASHBOARD</FocusGhostButton>
        </MenuItem>
        <MenuItem
          onClick={handleClose}
          component={"a"}
          href="https://delysium.gitbook.io/delysium-one-whitepaper/user-guidance"
          target="_blank">
          <FocusGhostButton>USER GUIDANCE</FocusGhostButton>
        </MenuItem>
        <MenuItem onClick={handleClose} component={Link} to={`/settings`}>
          <FocusGhostButton>ACCOUNT SETTINGS</FocusGhostButton>
        </MenuItem>
        <MenuItem
          onClick={() => {
            dispatch(logout(token));
            handleClose();
          }}>
          <FocusGhostButton>LOGOUT</FocusGhostButton>
        </MenuItem>
      </StyledMenu>
    </Box>
  );
};

export default UserProfileMenu;
